<template>
  <div class="company">
    <div class="company-box">
      <div class="title">
        {{ resDatas.title }}
      </div>
      <p class="liter-title">自由、轻松、治愈。用最精益求精的技术与信念给全世界带来欢乐</p>
      <div class="company-main">
        <ul>
          <li v-for="iten in resDatas.companyDets">
            <span>{{ iten.label }}</span><span><em v-if="iten.img"><img
                  :src="require('@/assets/images/' + iten.img + '')" alt=""></br> </em> <a :href="iten.url"
                target="_blank">{{ iten.url }}</a> {{ iten.content }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resDatas: "",
    };
  },
  props: {
    resData: {},
  },
  watch: {
    resData(newData) {
      this.resDatas = newData;
    },
  },
  mounted() {
    this.$parent.getlan();
  },
};
</script>

<style scoped>
.company {
  background: url("~@/assets/images/bg4.png") center no-repeat;
  padding-top: 10%;
}

.company-box {
  max-width: 1452px;
  margin: auto;
  background-color: #f6f6f6;
  box-sizing: border-box;
  padding: 0 10%;
}

.company-box .title {
  font-size: 40px;
  padding: 2%;
  font-weight: 600;
  text-align: center;
  background: url("~@/assets/images/title-bottom.png") center bottom no-repeat;
  background-size: auto;
}

.liter-title {
  text-align: center;
  margin-top: 2%;
}

.company-main {
  margin-top: 3%;
}

.company-main li {
  display: block;
  padding: 2%;
  font-size: 0;
  box-sizing: border-box;
}

.company-main li:nth-of-type(2n + 1) {
  background-color: #ebebeb;
}

.company-main li span {
  display: inline-block;
  font-size: 20px;
  font-weight: 600;
  vertical-align: middle;
  word-break: break-all;
  box-sizing: border-box;
}

.company-main li span:nth-of-type(1) {
  width: 34%;
  text-align: center;
}

.company-main li span:nth-of-type(2) {
  width: 66%;
  color: #818181;
  padding: 0 1%;
}

.company-main li span img {
  width: 35%;
  vertical-align: middle;
}

@media screen and (max-width: 1000px) {
  .company {
    width: 90%;
    margin: auto;
  }

  .company-main li {
    padding: 1.5% 0;
  }

  .company-main li span {
    font-size: 18px;
  }

  .company-main li span:nth-of-type(1) {
    padding: 0 1.5%;
  }

  .company-main li span img {
    width: 50%;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/company.vue